/**
 * SettingsAccessRoute — 설정 페이지 공통 진입 가드
 *
 * V1173: ORG_USER 차단 (조회 권한 없음)
 * V1255 (RBAC policy revision): ORG_USER도 조회 전용으로 진입 허용 → 차단 로직 제거.
 *   편집 권한 차이는 useReadOnly 훅이 담당하고,
 *   변경 이력 등 ORG_ADMIN 전용 페이지는 OrgAdminRoute로 별도 격리.
 *
 * 현재는 ProtectedRoute 위의 단순 통과 래퍼이지만,
 * 향후 설정 페이지 공통 진입 가드(구독 만료 체크 등)를 둘 위치로 인터페이스를 유지함.
 */

interface SettingsAccessRouteProps {
  children: React.ReactNode;
}

export default function SettingsAccessRoute({
  children,
}: SettingsAccessRouteProps) {
  return <>{children}</>;
}
